export default __webpack_public_path__ + "static/media/placeholder.36ff9eb7.png";